<form [formGroup]="NETBANKING_FORM">
    <section class="NETBANKING_section wrapper">
        <div class="wrapperInner">
            <div class="innerWrapper">
                <div class="cardWrapper">
                    <mat-form-field appearance="outline" floatLabel="always" class="w-75">
                        <mat-label>Select Net Banking</mat-label>
                        <input matInput placeholder="Select Net Banking" formControlName="net_banking_value" [value]="selectedNETBANKING" readonly>
                        <mat-error *ngIf="NETBANKING_FORM.controls['net_banking_value'].hasError('required')"><strong>Select Net Banking</strong> is required.</mat-error>
                    </mat-form-field>
                    <div class="payment_list">
                        <mat-radio-group formControlName="net_banking_value">
                            <mat-radio-button *ngFor="let item of NETBANKING_LIST  | bankingOdder: term ; let i = index" color="primary" [value]="item" (change)="onRadiowalletChange($event)">
                              <div class="paymentwrap">
                                <img [src]="item.logo" [alt]="item.name" class="img-fluid" onerror="this.src='../../../assets/main/payment_dummy.png'">&nbsp;&nbsp;<span>{{item.name}}</span>
                              </div>
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </div>
        </div>
    </section>
</form>